import { fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {
  logout,
  saveLastRoute,
  setPendingReauthIdentity,
  showLoginModal,
} from "./authSlice";

/**
 * REAL baseQuery (function)
 */
const rawBaseQuery = fetchBaseQuery({
  baseUrl: "/",
  credentials: "include",

  prepareHeaders: (headers, { getState, endpoint }) => {
    const token = getState().auth?.token;

    // The re-login call must never carry the dead token: the API rejects an
    // expired Bearer during authentication, before the login view runs, so the
    // first attempt from the "Login Required" modal would always 401.
    if (token && endpoint !== "login") {
      headers.set("Authorization", `Bearer ${token}`);
    }

    return headers;
  },
});

/**
 * Wrapper
 */
export const baseQueryWithReauth = async (args, api, extraOptions) => {
  let result = await rawBaseQuery(args, api, extraOptions);

  // Signing OUT with a token the server already rejects answers 401. That is
  // the expected outcome of the request, not a session to rescue — prompting
  // for re-authentication there pops "Login Required" over somebody who just
  // asked to leave, and the modal cannot be dismissed into a working session.
  const url = typeof args === "string" ? args : args?.url ?? "";
  const isLogoutCall = url.includes("api/user/logout");

  if (result?.error?.status === 401 && !isLogoutCall) {
    const state = api.getState();

    if (!state.auth.showLoginModal) {
      api.dispatch(saveLastRoute(window.location.pathname));
    //   api.dispatch(logout());
      // TIP-511 — pin the modal to the account whose session just died. The
      // store is deliberately NOT cleared here: an expiry mid-checkout must
      // keep its in-progress state. The cross-user leak is closed instead at
      // re-login, where a changed identity purges identity-scoped storage.
      api.dispatch(setPendingReauthIdentity(state.auth?.userInfo?.email ?? null));
      api.dispatch(showLoginModal());
    }
  }

  return result;
};
